import { useState } from "react";

const useUndo = () => {
  const [undoHistory, setUndoHistory] = useState([]);

  const addToUndoHistory = (history) =>
    setUndoHistory((prevHistory) => [...prevHistory, history]);

  const undo = () => {
    const lastItem = undoHistory[undoHistory.length - 1];
    setUndoHistory((prevHistory) =>
      prevHistory.slice(0, prevHistory.length - 1),
    );
    return lastItem;
  };

  return {
    undoHistory,
    addToUndoHistory,
    undo,
  };
};

export default useUndo;
